import { forwardRef, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";

import { useDispatch } from "react-redux";
import { Modal, Dropdown } from "react-bootstrap";

import { CgProfile } from "react-icons/cg";
import { RiArrowDropDownLine } from "react-icons/ri";

import { logoutAuth } from "../../app/auth";
import SettingProfile from "../SettingProfile";

export default function Header({ auth }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [authData, setAuthData] = useState("");
    const [visibleModal, setVisibleModal] = useState(false);

    const authLogout = () => {
        dispatch(logoutAuth());
    };

    useEffect(() => {
        setAuthData(auth);
    }, [auth]);

    const CustomToggle = forwardRef(({ children, onClick }, ref) => (
        <div
            style={{ color: "#212529" }}
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
        >
            {children}
        </div>
    ));

    return (
        <nav className="navbar navbar-light bg-light">
            <div className="container-fluid">
                <div className="w-100">
                    <div className="d-flex justify-content-between flex-nowrap align-items-center">
                        <div>
                            <div
                                className="d-flex justify-content-start flex-nowrap align-items-center"
                                onClick={() => navigate("/")}
                                style={{ cursor: "pointer" }}
                            >
                                <div className="mx-2 d-none d-md-inline" style={{ fontSize: 22 }}>
                                    R-DNAM
                                </div>
                                <div className="mx-2 d-inline d-md-none" style={{ fontSize: 22 }}>
                                    R-DNAM
                                </div>
                            </div>
                        </div>
                        <div>
                            {authData && authData.auth_data ? (
                                <div className="d-flex justify-content-end flex-nowrap align-items-center">
                                    <div>
                                        <Dropdown>
                                            <Dropdown.Toggle as={CustomToggle}>
                                                <div className="d-flex flex-nowrap align-items-center setting-profile py-0">
                                                    <CgProfile style={{ fontSize: 22 }} />
                                                    <div className="mx-2">{authData?.auth_data?.name}</div>
                                                    <div>
                                                        <RiArrowDropDownLine style={{ fontSize: 24 }} />
                                                    </div>
                                                </div>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu style={{ width: "100%" }}>
                                                <Dropdown.Item onClick={() => setVisibleModal(true)}>ตั้งค่าบัญชี</Dropdown.Item>
                                                {authData?.auth_data?.role === "admin" && (
                                                    <>
                                                        <Dropdown.Item>
                                                            <Link to="/backend" style={{ color: "#212529" }}>
                                                                จัดการข้อมูล
                                                            </Link>
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => {
                                                            window.open(`/service/api/v1/docs?token=${localStorage.getItem('rdnatoken')}`, "_blank");
                                                        }}>API Documentation</Dropdown.Item>
                                                    </>
                                                )}
                                                {authData?.auth_data?.role === "staff" && (
                                                    <Dropdown.Item>
                                                        <Link to="/backend" style={{ color: "#212529" }}>
                                                            จัดการข้อมูล
                                                        </Link>
                                                    </Dropdown.Item>
                                                )}
                                                
                                                <Dropdown.Item onClick={() => authLogout()}>ออกจากระบบ</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                    {/* <div>
                                        <button type="button" className="btn btn-outline-dark btn-sm" onClick={() => authLogout()}>
                                            ออกจากระบบ
                                        </button>
                                    </div> */}
                                </div>
                            ) : (
                                <button type="button" className="btn btn-outline-dark btn-sm" onClick={() => navigate("/login")}>
                                    เข้าสู่ระบบ
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Modal centered show={visibleModal} onHide={() => setVisibleModal(false)}>
                <Modal.Body>
                    <SettingProfile auth={authData} setVisibleModal={setVisibleModal} />
                </Modal.Body>
            </Modal>
        </nav>
    );
}
